import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/expected-value-calculator',
  component: () => import('../../routes/ExpectedValueCalculator.svelte'),
  card: {
    id: 'expected-value-calculator',
    title: 'Expected Value Calculator',
    description: 'Calculate the expected value, variance, and standard deviation of any probability distribution to make better decisions.',
    icon: 'analytics',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/expected-value-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Expected Value Calculator – Probability Distribution EV',
    description: 'Free expected value calculator. Calculate EV, variance, and standard deviation of any probability distribution. Make better decisions using weighted probability analysis.',
  },
};

export default meta;